import styled from 'styled-components';
import { colors } from 'nicollet-tokens';
import { Link as StyledLink } from '../../../Link/index.js';
import { focusDotStyles } from './styles.js';

const OptionLink = styled(StyledLink)`
  display: block;
  position: relative;
  height: 45px;
  border-top: 1px solid ${colors.border.separator.default};
  color: ${colors.link.onLight.focus};
  text-decoration: none;

  &:focus {
    outline: none;
    text-decoration: underline;
    ${focusDotStyles};
  }

  margin-bottom: 0;
`;

export { OptionLink };
